// extracted by mini-css-extract-plugin
export default {"button":"_0Nh1-Hmlmf","title":"_36usU5mdhA","icon":"_8LYWebixGZ","content":"ryExnrNFkN","expanded":"m79c+LuCvj"};